// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
Blurb.propTypes = {
  handleModal: PropTypes.func.isRequired,
};

// this are the details for this attestation field
export function Config() {
  return {
    name: 'txDefensiveDrivingASC', // this used as the field name as well as the unique identifier
    productIds: [
      // 'f5581a9d-6afd-4f94-9d01-ecd6b15a5d4c', // Texas Defensive Driving - PID=819
      // 'cc2bfef8-2190-4bcf-9301-08dce3af17cb', // Texas Defensive Driving, Streaming - PID=1419
      // 'bcf442c0-afbb-457f-3125-08dcf8db6a48', // Texas Online Defensive Driving + Vehicle Maintenance Course
      // 'bcf4333f-334b-4363-3126-08dcf8db6a48', // Texas Online Defensive Driving, Streaming + Vehicle Maintenance Course
    ],
    errorMsg: `The Student must accept the <strong>Texas Online Defensive Driving enrollment contract</strong> by typing checking the box.`,
    onlyForBulk: false, // set to true if this attestation is only for bulk purchase
    type: 'checkbox', // iAgree, signature, checkbox
  };
}

// this is the blurb we display to tell the user what this attestation field is for
export function Blurb() {
  return (
    <>
      By checking this box, the Student accepts the{' '}
      <a
        href="https://cdn.certus.com/global/pdf/tx-dd-enrollment-contract-asc.pdf"
        target="_blank"
        rel="noopener nofollow noreferrer"
      >
        Texas Online Defensive Driving enrollment contract
      </a>
      .
    </>
  );
}

// this is the explaination of the attestation, the full details of what the user is aggreeing to
export function ModalContent() {
  return null;
}
